import { render, staticRenderFns } from "./notifier.vue?vue&type=template&id=2d93edad&"
import script from "./notifier.vue?vue&type=script&lang=ts&"
export * from "./notifier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d93edad')) {
      api.createRecord('2d93edad', component.options)
    } else {
      api.reload('2d93edad', component.options)
    }
    module.hot.accept("./notifier.vue?vue&type=template&id=2d93edad&", function () {
      api.rerender('2d93edad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/notifier.vue"
export default component.exports